import Search from '../src/Search/index';
export default Search;
